module.exports = __webpack_public_path__ + "img/poster.c909a264.jpeg";